import { User, Media, MediaFolder, VimeoUser } from "../types";

export const toUser = (data: any): User => {
  return {
    id: data.id,
    email: data.email,
    nominative: data.nominative,
    role: data.roleId ? data.roleId : null,
  };
};

export const toHHMMSS = (seconds: number) =>
  new Date(seconds * 1000).toISOString().substr(11, 8);

export const toSeconds = (hms: string) => {
  const a = hms.split(":"); // split it at the colons

  // minutes are worth 60 seconds. Hours are worth 60 minutes.
  return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
};

export const toMedia = (data: any): Media => ({
  duration: data.duration,
  externalId: data.uri.split("/").pop(), // /videos/671166373 -> 671166373
  link: data.link,
  name: data.name,
  uri: data.uri,
  pictures: data.pictures,
  description: data.description,
  createdAt: new Date(data.createdAt),
  programId: data.programId || "",
});

export const toMediaFolder = (data: any): MediaFolder => ({
  name: data.name,
  projectId: data.project_id,
  resourceKey: data.resouce_key,
  uri: data.uri,
  description: data.description,
});

export const toVimeoUser = (data: any): VimeoUser => ({
  uri: data.uri,
  numberOfVideos: data.number_of_videos,
  numberOfFolders: data.number_of_folders,
});
